import { formatNumber, wrapBidiIsolate } from "src/utils/numberFormat";
import type { SocialValueFormat } from "./socialReportConfig";

const EM_DASH = "—";

export function formatSocialValue(
  value: number | null | undefined,
  format: SocialValueFormat,
  language: string
): string {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return EM_DASH;
  }

  if (format === "percent") {
    return wrapBidiIsolate(
      `${formatNumber(value, { minimumFractionDigits: 1, maximumFractionDigits: 1 }, language)}%`
    );
  }

  const formatted = formatNumber(Math.round(value), {}, language);
  return format === "signed" && value > 0 ? wrapBidiIsolate(`+${formatted}`) : formatted;
}

/** Compact axis labels: 1.28M / 176K. */
export function formatSocialAxisValue(
  value: number,
  format: SocialValueFormat,
  language: string
): string {
  if (format === "percent") {
    return `${formatNumber(value, { maximumFractionDigits: 1 }, language)}%`;
  }
  const abs = Math.abs(value);
  if (abs >= 1_000_000) {
    return `${formatNumber(value / 1_000_000, { maximumFractionDigits: 1 }, language)}M`;
  }
  if (abs >= 1_000) {
    return `${formatNumber(value / 1_000, { maximumFractionDigits: 0 }, language)}K`;
  }
  return formatNumber(value, { maximumFractionDigits: 0 }, language);
}

export function socialChangePercent(
  current: number | null | undefined,
  previous: number | null | undefined
): number | undefined {
  if (
    current === null ||
    current === undefined ||
    previous === null ||
    previous === undefined ||
    previous === 0
  ) {
    return undefined;
  }
  return Math.round(((current - previous) / Math.abs(previous)) * 10000) / 100;
}
